import React from 'react';
import { useClinicalDemo } from '../../contexts/ClinicalDemoContext';
import { visits } from '../../data/clinicalDemo';
import { DemoSectionHeader } from '../demoShell/DemoSectionHeader';
import { VisitColumn } from './VisitColumn';
export function VisitTimeline() {
  const {
    state
  } = useClinicalDemo();
  const canEdit = state.ui.workspace === 'clinician';
  return <div data-id="element-252" data-mp="6l8qj6h43k0y">
      <DemoSectionHeader title="Visit Timeline" description={canEdit ? 'Two visits side by side. Every entry shows its category, author role and time. Add entries to unreviewed visits; reviewed visits accept addenda only.' : 'Two visits side by side. Entries are added in the Clinician Workspace.'} data-id="element-253" data-mp="bmod52yxtylg" />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-254" data-mp="pdb6sgpucyao">
        {visits.map(visit => <VisitColumn key={visit.id} visit={visit} canEdit={canEdit} data-id="element-255" data-mp="uf0kk44g7q2g" />)}
      </div>
    </div>;
}